import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { combineLatest, Subscription } from 'rxjs';
import { delay, filter, tap } from 'rxjs/operators';

import { layoutAnimationEnterAppAnimation } from '../../animations/layout-external.animation';

import { ScreenModeEnum } from '@lib-shared/screen/models/screen-mode.enum';

import { AuthHelperService } from '@lib-core/auth/services/auth-helper.service';
import { LayoutAnimationService } from '@lib-core/login/services/layout-animation.service';
import { ScreenHelperService } from '@lib-shared/screen/services/screen-helper.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-layout-external',
  templateUrl: './layout-external.component.html',
  styleUrls: ['./layout-external.component.scss'],
  animations: [layoutAnimationEnterAppAnimation],
  standalone: true,
  imports: [RouterOutlet, AsyncPipe],
})
export class LayoutExternalComponent implements OnInit, OnDestroy {
  // animations
  animationLogin: string;

  // subscriptions
  private subscriptions: Subscription = new Subscription();

  /**
   * constructor
   *
   */
  constructor(
    public layoutAnimationService: LayoutAnimationService,
    private router: Router,
    private authHelperService: AuthHelperService,
    private screenHelperService: ScreenHelperService,
  ) {}

  /**
   * ngOnInit
   *
   */
  ngOnInit(): void {
    this.layoutAnimationService.init();

    // subscribe to enterAppAnimationActive
    this.subscriptions.add(
      combineLatest([
        this.layoutAnimationService.isEnterAppAnimationActive$,
        this.screenHelperService.screenMode$,
      ])
        .pipe(
          delay(0), // quickfix to prevent ExpressionChangedAfterItHasBeenCheckedError when animation is lunched into ngOninit
          filter(([isActive]) => isActive),
          tap(([active, screenMode]) => {
            this.animationLogin =
              screenMode === ScreenModeEnum.Desktop
                ? 'loginSuccessDesktop'
                : 'loginSuccessMobile';
          }),
        )
        .subscribe(),
    );

    // subscribe to enterAppAnimationCompleted
    this.subscriptions.add(
      this.layoutAnimationService.isEnterAppAnimationCompleted$
        .pipe(
          filter((completed) => completed),
          tap(() => {
            this.router.navigate([this.authHelperService.getAppUrl()]).catch();
          }),
        )
        .subscribe(),
    );
  }

  /**
   * ngOnDestroy
   *
   */
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /**
   * onEnterAppAnimationComplete
   *
   */
  onEnterAppAnimationComplete(event: any): void {
    if (event.totalTime > 0) {
      this.layoutAnimationService.isEnterAppAnimationCompleted$.next(true);
    }
  }
}
